import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Use this helper when you want to prevent users from selecting/highlighting UI text (commonly for buttons).
export function noTextSelect(...inputs: ClassValue[]) {
  return cn("select-none", ...inputs)
}
